import React from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as applicationActions from '../../actions/application';
import { APPLICATION_CONTEXTS } from '../../constants';
import { ThemeProvider } from 'styled-components';
import { availableThemes, getTheme } from '../../themes';
import Routes from './routes';
import PopupMenu from '../common/popupMenu';
import './globalStyles';
import GenericTheme from '../../themes/Generic';

class App extends React.Component {
  state = {
    currentTheme: 'Default',
    popupMenuLinks: [
      {
        text: 'Home',
        action: () =>
          (window.location.href = 'https://demo.sonifi.com/sales/healthcare'),
      },
      {
        text: 'Welcome Channel',
        link: '/welcome',
      },
      {
        text: 'Video Call',
        link: '/telehealth',
      },
      {
        text: 'IPG',
        link: '/ipg',
      },
      {
        text: 'Main Menu',
        link: '/main_menu',
      },
      {
        text: 'Education Prompts',
        link: `/assigned_education/prompts/${encodeURIComponent(
          this.props.location.pathname
        )}`,
      },
      {
        text: 'Pharmacy Notification',
        link: '/pharmacy',
      },
      {
        text: 'STAYCAST',
        link: '/staycast',
      },
      {
        text: 'Bedside Shopping',
        link: '/retail_shopping',
      },
    ],
    availablePatients: this.constructPatients(),
    availableThemes: [],
    themeData: {},
  };

  constructPatients() {
    const patients = [
      {
        text: 'Default',
        value: 'default',
        link: '#',
        action: '',
      },
      {
        text: 'Ortho Patient',
        value: 'orthoPatient',
        link: '#',
        action: '',
      },
      {
        text: 'CHF Patient',
        value: 'chfPatient',
        link: '#',
        action: '',
      },
      {
        text: 'Pediatric Patient',
        value: 'pediatricPatient',
        link: '#',
        action: '',
      },
      {
        text: 'Oncology Patient',
        value: 'oncologyPatient',
        link: '#',
        action: '',
      },
    ];
    return patients.map((patients) =>
      Object.assign({}, patients, {
        action: () => this.props.actions.updateCurrentPatient(patients.value),
      })
    );
  }

  componentWillMount() {
    document.addEventListener('keyup', this.handleOnKeyUp.bind(this), false);
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleOnKeyUp.bind(this));
  }

  componentDidMount() {
    this.fetchThemeData();
  }

  // Fetch theme data from server
  fetchThemeData() {
    let themeArr = availableThemes.map((theme) =>
      Object.assign({}, theme, {
        action: () => this.setState({ currentTheme: theme.text }),
      })
    );
    fetch('https://demo.sonifi.com/sales/hc_themes/themeData.json')
      .then((response) => response.json())
      .then((data) => {
        this.setState({ themeData: data });
        for (const theme in data) {
          themeArr.push({
            text: theme,
            link: '#',
            action: () => this.setState({ currentTheme: theme }),
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });

    this.setState({ availableThemes: themeArr });
  }

  handleThemeChange(themeName) {
    if (this.state.themeData[themeName]) {
      return Object.assign({}, GenericTheme, {
        background: this.state.themeData[themeName].background,
        ipg_background: this.state.themeData[themeName].ipg_background,
        menu_background: this.state.themeData[themeName].menu_background,
        welcome_background: this.state.themeData[themeName].welcome_background,
      });
    } else {
      return getTheme(themeName);
    }
  }

  handleOnKeyUp(event) {
    if (this.props.context !== APPLICATION_CONTEXTS.SERVICES) {
      return;
    }
    switch (event.key.toLowerCase()) {
      case 'e':
        this.props.history.push('/welcome');
        break;
      case 'g':
        this.props.history.push('/ipg');
        break;
      case 'm':
        this.props.history.push('/main_menu');
        break;
      case 'p':
        // P simulates a "power-off" so we go to the overall demo's intro screen.
        // For now, that is a separate application so simulate the user clicking a link to that page.
        window.location.href = 'https://demo.sonifi.com/sales/healthcare';
        break;
      default:
        break;
    }
  }

  render() {
    return (
      <div className="app">
        <ThemeProvider theme={this.handleThemeChange(this.state.currentTheme)}>
          <Routes />
        </ThemeProvider>

        <PopupMenu
          buttonText="Quick Links"
          menuLinks={this.state.popupMenuLinks}
          top="730"
          left="0"
          hotkey="u"
        />
        <PopupMenu
          buttonText="Branding"
          menuLinks={this.state.availableThemes}
          top="730"
          left="200"
          hotkey="c"
        />
        <PopupMenu
          buttonText="Patient"
          menuLinks={this.state.availablePatients}
          top="730"
          left="400"
          hotkey="x"
        />
      </div>
    );
  }
}

const ConnectedApp = connect(
  (state) => ({
    context: state.application.currentContext,
    currentPatient: state.application.currentPatient,
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        ...applicationActions,
      },
      dispatch
    ),
  })
)(App);

export default withRouter(ConnectedApp);
